export default __webpack_public_path__ + "static/heroSectionImgBg-d94d39d147042b7c2ac0de1b646045c0.png";